module.exports = __webpack_public_path__ + "img/Aura_meteor.8ecd7fe0.png";